import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SimilarWorks from './SimilarWorks';
import Filters from '../../components/Filters';

import {
  Wrapper,
  Actions,
  SaveBtn,
  TaskDescription,
  Tasks,
  RecentWorks,
  RateComment,
  LeftActions,
  SearchBox,
} from './style';
import RealtimeDate from '../../components/RealtimeDate';
import SupervisorCard from '../../components/Cards/WorkCards/Supervisor';

import { Empty, Pagination } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import works from '../../services/works';
import { workConstructor } from '../../utils/workConstructor';

import rating from '../../services/rating';
import Spinner from '../../components/Spinner/FullScreen';
import { Input } from 'antd';
import { NoData } from '../GroupSecretary/NewWorks/style';
import MultiDatePicker from './../../components/FormElements/MultiDatePicker/index';
import moment from 'moment';
import Select from '../../components/FormElements/Select';
import { buttons } from './helper';
import RatedWork from '../../components/Cards/TaskCard';
import UserInActive from './UserInActive';
import userService from 'services/users';

const COMMON_RATE = 100;

const { Search } = Input;

export default () => {
  const [bal, setBal] = useState(0);
  const { categories, regions, groups, users } = useSelector(
    (state) => state.appReducer
  );
  const { role, groupId } = useSelector((state) => state.authReducer);
  const provinceId = localStorage.getItem('provinceId');
  const [loading, setLoading] = useState(true);
  const [rateComment, setRateComment] = useState([]);
  const [worksData, setWorksData] = useState([]);
  // const [objectsList, setObjectsList] = useState([]);
  const [selectedRates, setSelectedRates] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [similarWorkPageNum, setSimilarWorkPageNum] = useState(1);
  const { constructorMethod } = workConstructor();
  const [similarWorks, setSimilarWorks] = useState([]);
  const [similarWorksCount, setSimilarWorksCount] = useState(0);
  const [worksTotal, setWorksTotal] = useState(0);
  const [checkList, setCheckList] = useState([]);
  const [determinedDays, setDeterminedDays] = useState([]);
  const pureToday = new Date();
  const pureYesterday = new Date(pureToday);
  pureYesterday.setDate(pureYesterday.getDate() - 1);
  const [startDate, setStartDate] = useState(pureYesterday);
  const [search, setSearch] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');
  const [active, setActive] = useState(2);
  const [allUsers, setAllUsers] = useState([]);
  const [usersDataTotal, setUsersDataTotal] = useState(0);
  const [usersPageCount, setUsersPageCount] = useState(1);
  const [userLimit, setUserLimit] = useState(10);

  useEffect(() => {
    if (role === 'regionsupervisor') {
      setSelectedGroup(groupId);
    }
  }, []);
  // get one work
  const fetchWorks = () => {
    const common = { categories, regions, groups, users };
    setLoading(true);
    const selectedDate = moment(startDate).format('YYYY-MM-DD');
    const postData = {
      date: selectedDate,
      province: provinceId,
      page: pageNum,
      limit: active > 2 ? 10 : 1,
      status: active > 2 ? 3 : 2,
    };
    if (selectedGroup?.length) {
      postData['group'] = selectedGroup;
    }
    const determinedData = {
      date: moment().format('YYYY-MM-DD'),
      status: 2,
    };
    const pageType = active > 2 ? 'send' : 'new';
    works
      .getWorkDays(determinedData)
      .then((res) => {
        setDeterminedDays(res);
      })
      .catch((err) => console.error(err));
    works
      .getSpecialWorksSupervisor(postData, pageType)
      .then(({ docs, totalDocs }) => {
        setWorksTotal(totalDocs);
        const workerData = constructorMethod(docs, common);
        setWorksData(workerData);
        if (workerData[0]?.group) {
          setSelectedGroup(workerData[0]?.group);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));

    role === 'regionsupervisor' &&
      userService
        .getUsersByFilter({ page: usersPageCount, limit: userLimit })
        .then((res) => {
          const userData = constructorMethod(res.docs, common);
          setUsersDataTotal(res?.totalDocs);
          const finalUserData = userData.map((item) => ({
            _id: item?._id,
            user_name:
              item.firstName + ' ' + item.lastName + ' ' + item.middleName,
            object: item?.object?.title
              ? item?.object?.title
              : item.objectName
              ? item.objectName
              : '-',
            region: item.regionName ?? '-',
            inActive: item?.inActive
              ? item.inActive.start + ', ' + item.inActive.end
              : 'faol',
          }));

          setAllUsers(finalUserData);
        });
  };

  useEffect(() => {
    fetchWorks();
    setSelectedRates([]);
  }, [startDate, pageNum, active, selectedGroup, usersPageCount, userLimit]);

  const handleChangeDateInput = (dateString) => {
    setStartDate(dateString);
    setPageNum(() => 1);
  };

  // get all sub Objects
  // useEffect(() => {
  //   (async () => {
  //     const data = {
  //       all: 'all',
  //     };
  //     objects
  //       .getAllSubsList(data)
  //       .then((subsList) => {
  //         setObjectsList(subsList);
  //       })
  //       .catch((err) => console.error(err));
  //   })();
  // }, []);
  // get checklist by group id
  useEffect(() => {
    if (selectedGroup) {
      rating
        .getAll({ group: selectedGroup || worksData[0]?.group })
        .then((resp) => setCheckList(resp))
        .catch((err) => console.error(err));
    }
  }, [selectedGroup]);

  // change rate and rate comment in rated work data
  useEffect(() => {
    if (worksData.length > 0) {
      if (worksData[0]?.rate) {
        setBal(() => worksData[0]?.rate * 1);
        setRateComment(worksData[0]?.rateComment?.split('/'));
      } else {
        setBal(COMMON_RATE);
      }
    }
  }, [worksData]);

  // get rated work
  useEffect(() => {
    const common = { categories, regions, groups, users };
    if (worksData.length > 0) {
      let postWork = {
        limit: 10,
        page: similarWorkPageNum,
        province: provinceId,
        region: worksData[0]?.region,
        category: worksData[0]?.category,
        status: 3,
      };
      if (worksData[0]?.objects && worksData[0]?.objects.length) {
        postWork['objects'] = [worksData[0]?.objects[0]._id];
      }
      if (search.length > 0) {
        const { category, ...rest } = postWork;
        postWork = rest;
        postWork['search'] = search;
      }
      works
        .getAll(postWork)
        .then(({ docs, totalDocs }) => {
          setSimilarWorksCount(totalDocs);
          const similarWorks = constructorMethod(docs, common);
          setSimilarWorks(similarWorks);
        })
        .catch((err) => console.error(err));
    }
  }, [search, selectedGroup, similarWorkPageNum, worksData]);

  const onSearch = (value) => {
    if (value.length > 0) {
      const searchVal = value.trim();
      setSearch(searchVal);
    }
  };

  const handleSaveWork = () => {
    setLoading(true);
    const id = worksData[0]._id;
    const putData = {
      bestRate: worksData[0]?.bestRate,
      category: worksData[0]?.category,
      checklists: worksData[0]?.checklists,
      createdAt: worksData[0].createdAt,
      media: worksData[0].media,
      province: provinceId,
      rate: bal * 1,
      rateComment: rateComment.join('/'),
      region: worksData[0]?.region,
      group: worksData[0]?.group,
      status: 2,
      subCategory: worksData[0]?.subCategory,
      uploadTime: worksData[0]?.uploadTime,
      user: worksData[0]?.user._id,
      desc: worksData[0]?.desc,
    };
    works
      .update(id, putData)
      .then(() => {
        fetchWorks();
        setSelectedRates([]);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectedRates.length > 0) {
      let descText = [];
      checkList.forEach((item) => {
        if (selectedRates.includes(item._id)) {
          descText.push(item.title);
        }
      });
      setRateComment(descText);
      let sum = 0;
      checkList.forEach((item) => {
        if (selectedRates.includes(item._id)) {
          sum += item.rate;
        }
      });
      sum = COMMON_RATE - sum;
      setBal(sum);
    } else {
      setRateComment([
        'Гуруҳ рахбари томонидан ишлар қониқарли даражада бажарилган!',
      ]);
      setBal(COMMON_RATE);
    }
  }, [selectedRates]);

  const handleChecklist = (workId, rateId) => {
    if (selectedRates.includes(rateId)) {
      setSelectedRates(selectedRates.filter((rate) => rate !== rateId));
    } else {
      setSelectedRates((prev) => [...prev, rateId]);
    }
  };
  const reloadHandler = () => {
    fetchWorks();
  };

  const handleActive = (item) => {
    setActive(item?.value);
  };
  if (loading) return <Spinner />;
  return (
    <Wrapper>
      <div className='top-actions'>
        <LeftActions>
          <RealtimeDate />
          <Filters
            list={
              role === 'regionsupervisor'
                ? [
                    ...buttons,
                    {
                      id: 3,
                      title: 'Ишчилар',
                      value: 4,
                    },
                  ]
                : buttons
            }
            active={active}
            handleActive={handleActive}
          />
        </LeftActions>
        <div className='right-wrapper'>
          {active !== 4 && (
            <div className='inputs'>
              <div className='select__sector__input'>
                <Select
                  handleChange={(value) => setSelectedGroup(value)}
                  name='sector'
                  size='large'
                  options={
                    role === 'regionsupervisor'
                      ? groups.filter((item) => item._id === groupId)
                      : groups
                  }
                  defaultVal={selectedGroup}
                  // title="Гуруҳ"
                />
              </div>
              <div>
                <MultiDatePicker
                  dates={determinedDays}
                  onChange={handleChangeDateInput}
                  startDate={startDate}
                />
              </div>
            </div>
          )}
          <button className='reload-button' onClick={reloadHandler}>
            <ReloadOutlined className='reload-outlined' />
          </button>
        </div>
      </div>
      {active !== 4 && worksData?.length > 0 ? (
        <div
          style={{
            padding: '20px',
            backgroundColor: '#fff',
            minHeight: '100%',
            borderRadius: '10px',
          }}
        >
          {worksData.map((work, index) =>
            work?.rate === null ? (
              <SupervisorCard
                key={`${index * 2}`}
                medium
                data={work}
                checkList={checkList}
                bal={bal}
                rate={selectedRates}
                handleChecklist={handleChecklist}
              />
            ) : (
              <RatedWork
                key={`${index * 3}`}
                data={work}
                medium
                objectsList={{}}
              />
            )
          )}

          <TaskDescription>
            {active === 2 && (
              <RateComment>
                <ul className='description'>
                  {rateComment?.length > 0 ? (
                    rateComment.map((rate, indx) => (
                      <li key={`${indx + 1}`}>{rate}</li>
                    ))
                  ) : (
                    <span>Критериялар танланмаган...!</span>
                  )}
                </ul>
              </RateComment>
            )}

            {active > 2 && worksTotal > 10 ? (
              <Actions>
                <Pagination
                  current={pageNum}
                  total={worksTotal}
                  onChange={(page) => setPageNum(page)}
                />
              </Actions>
            ) : (
              <>
                <Actions>
                  {active < 3 && (
                    <SearchBox>
                      {worksData[0]?.objects &&
                        worksData[0]?.objects.length > 0 && (
                          <>
                            <div>Обеъкть:</div>
                            <div className='objectName'>
                              {worksData[0]?.objects?.map((item, indx) => (
                                <span key={`${indx + 1}`}>{item.title}</span>
                              ))}
                            </div>
                          </>
                        )}
                      <Search
                        className='search-input'
                        placeholder='Матн бўйича қидирув...'
                        allowClear
                        onSearch={onSearch}
                        size='large'
                      />
                    </SearchBox>
                  )}

                  <Tasks>{active < 3 && `${worksTotal}`}</Tasks>
                  {active < 3 && (
                    <SaveBtn onClick={handleSaveWork}>Сақлаш</SaveBtn>
                  )}
                </Actions>
              </>
            )}
          </TaskDescription>
          {active === 2 && (
            <RecentWorks>
              <div className='found-works'>
                <p>Қидирув бўйича топилган натижалар</p>{' '}
                <span className='total'>{similarWorksCount} та</span>
              </div>
              {similarWorks?.map((item, indx) => (
                <SimilarWorks key={`${indx + 1}`} data={item} />
              ))}
              {similarWorksCount > 10 && (
                <Pagination
                  current={similarWorkPageNum}
                  total={similarWorksCount}
                  onChange={(page) => setSimilarWorkPageNum(page)}
                />
              )}
            </RecentWorks>
          )}
        </div>
      ) : (
        active !== 4 && (
          <NoData>
            <Empty
              description={
                <h1>Белгиланган кун учун қилинган ишлар топилмади!</h1>
              }
            />
          </NoData>
        )
      )}

      {active === 4 && (
        <>
          <UserInActive
            allUsers={allUsers}
            refreshData={fetchWorks}
            usersDataTotal={usersDataTotal}
            setUsersPageCount={setUsersPageCount}
            usersPageCount={usersPageCount}
            setUserLimit={setUserLimit}
            userLimit={userLimit}
          />
        </>
      )}
    </Wrapper>
  );
};
